import IsAuthenticated from "@/permissions/IsAuthenticated";
import HasGroupAccess from "@/permissions/HasGroupAccess";
import {
  GROUP_NAME,
  HOME_ROUTE_NAME,
  TITLE
} from "@/modules/campos_novos/settings";

const hasGroupAccess = HasGroupAccess(GROUP_NAME);
const isAuthenticated = IsAuthenticated();

export default [
  {
    path: "/campos-novos",
    name: HOME_ROUTE_NAME,
    meta: {
      title: TITLE,
      permissions: [isAuthenticated, hasGroupAccess]
    },
    component: () =>
      import(
        /* webpackChunkName: "campos_novos" */ "@/modules/campos_novos/views/CamposNovos.vue"
      ),
    redirect: {
      name: `${HOME_ROUTE_NAME}.alerts`
    },
    children: [
      {
        path: "alerts",
        name: `${HOME_ROUTE_NAME}.alerts`,
        meta: {
          title: "Alertas"
        },
        component: () =>
          import(
            /* webpackChunkName: "campos_novos" */ "@/modules/campos_novos/views/Alerts.vue"
          )
      },
      {
        path: "reservoir",
        name: `${HOME_ROUTE_NAME}.reservoir`,
        meta: {
          title: "Nível Reservatório"
        },
        component: () =>
          import(
            /* webpackChunkName: "campos_novos" */ "@/modules/campos_novos/views/Reservoir.vue"
          )
      },
      {
        path: "prisms",
        name: `${HOME_ROUTE_NAME}.prisms`,
        meta: {
          title: "Prismas"
        },
        component: () =>
          import(
            /* webpackChunkName: "campos_novos" */ "@/modules/campos_novos/views/Prisms.vue"
          )
      },
      {
        path: "sensors",
        name: `${HOME_ROUTE_NAME}.sensors`,
        meta: {
          title: "Sensors"
        },
        component: () =>
          import(
            /* webpackChunkName: "campos_novos" */ "@/modules/campos_novos/views/Sensors.vue"
          )
      },
      {
        path: "visualization",
        name: `${HOME_ROUTE_NAME}.visualization`,
        meta: {
          title: "Visualização"
        },
        component: () =>
          import(
            /* webpackChunkName: "campos_novos" */ "@/modules/campos_novos/views/Visualization.vue"
          )
      }
    ]
  },
  {
    path: "/campos-novos/simulator",
    name: `${HOME_ROUTE_NAME}.simulator`,
    meta: {
      title: "Simulador",
      permissions: [isAuthenticated, hasGroupAccess]
    },
    component: () =>
      import(/* webpackChunkName: "campos_novos" */ "./views/Simulator.vue"),
    redirect: {
      name: `${HOME_ROUTE_NAME}.simulator.input`
    },
    children: [
      {
        path: "input",
        name: `${HOME_ROUTE_NAME}.simulator.input`,
        meta: {
          title: "Dados de entrada"
        },
        component: () =>
          import(
            /* webpackChunkName: "campos_novos" */ "./views/simulator/InputData"
          )
      },
      {
        path: "calculate",
        name: `${HOME_ROUTE_NAME}.simulator.calculate`,
        meta: {
          title: "Calcular"
        },
        component: () =>
          import(
            /* webpackChunkName: "campos_novos" */ "./views/simulator/Calculate.vue"
          )
      },
      {
        path: "output",
        name: `${HOME_ROUTE_NAME}.simulator.output`,
        meta: {
          title: "Resultados"
        },
        component: () =>
          import(
            /* webpackChunkName: "campos_novos" */ "./views/simulator/OutputData"
          )
      }
    ]
  }
];
